import React, { FC } from 'react';
import FormItemLabel from 'antd/es/form/FormItemLabel';
import { Switch } from 'antd';

import s from './CustomSwitch.module.scss';
interface ICustomInput {
  label: string;
  name: string;
  value: boolean;
  handleChange: (name: string, value: boolean) => unknown;
}
export const CustomSwitch: FC<ICustomInput> = ({ label, name, value, handleChange }) => {
  return (
    <div className={s.CustomSwitch}>
      <div style={{ height: 12 }}></div>
      <div className={`${s.field} ${s.switchWrapper}`}>
        <FormItemLabel prefixCls={label} label={label} htmlFor={name} />
        <Switch onChange={() => handleChange(name, !value)} checked={value} />
      </div>
    </div>
  );
};
